<template>
  <div>
    <div class="row my-1" v-for="(item, index) of items" :key="index">
      <div class="col-md-4">
        <input
          type="tel"
          v-numeric
          v-model="item[qtdName]"
          class="form-control"
          :placeholder="qtdText"
          :disabled="disabled"
          @keyup="alterou()"
          @keydown="alterou()"
        />
        <template v-if="(!item[qtdName] || item[qtdName] <= 0 ) && (item[selectName])">
          <span class="text text-danger">Você deve informar a quantidade</span>
          <!-- VALIDATION PURPOSE: -->
          <div class="form-group required">
            <input
              type="hidden"
              class="form-control"
            />
          </div>
        </template>
      </div>
      <div class="col-md-4">
        <select-component
          class="form-control"
          :name="selectName"
          v-model="item[selectName]"
          :disabled="disabled"
          ref="selectComponent"
          @change="alterou()"
        >
          <option value>{{ selectText }}</option>
          <option v-for="(option, optionKey) of options" :key="optionKey" :value="option[cod]">{{ option.nome }}</option>
        </select-component>
        <template v-if="(item[qtdName]) && (!item[selectName])">
          <span class="text text-danger">Você deve selecionar uma opção</span>
          <!-- VALIDATION PURPOSE: -->
          <div class="form-group required">
            <input
              type="hidden"
              class="form-control"
            />
          </div>
        </template>
      </div>
      <div class="col-md-3">
        <input
          type="text"
          name="observations"
          v-model="item.observations"
          class="form-control"
          placeholder="Outro..."
          v-if="isOutros(options[item[selectName]-1])"
          :disabled="disabled"
          @keyup="alterou()"
          @keydown="alterou()"
        />
      </div>

      <div class="col-md-1">
        <input
          data-v-b5f495d8
          type="button"
          value="+"
          class="btn-control"
          v-if="index == items.length - 1"
          @click="onAddClick"
          :disabled="disabled"
        />
        <input
          data-v-b5f495d8
          type="button"
          value="-"
          class="btn-control"
          @click="onRemoveClick(index)"
          :disabled="disabled"
        />
      </div>
    </div>
    <div v-if="showTotal">
      <span class="text"><b>Total</b>: {{ Intl.NumberFormat('pt-BR').format(qtdSomatory) }}</span>
    </div>
    <div v-if="qtdSomatory > maxQtdSomatory">
      <span class="text text-danger">O somatório de quantidades deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(maxQtdSomatory) }}</span>
      <!-- VALIDATION PURPOSE: -->
      <div class="form-group required">
        <input
          type="hidden"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
    },
    options: {
      required: true,
    },
    cod: {
      required: true,
    },
    selectName: {
      required: true
    },
    selectText: {
      required: false,
      default: 'Selecione'
    },
    qtdName: {
      required: false,
      default: 'qtd'
    },
    qtdText: {
      required: false,
      default: 'Quantidade'
    },
    disabled: {
      required: false
    },
    maxQtdSomatory: {
      required: false
    },
    showTotal: {
      required: false,
      default: false
    }
  },
  data: () => ({
    items: [],
  }),
  watch: {
    options: function(val) {
      setTimeout(() => {
        this.$refs.selectComponent && this.$refs.selectComponent.forEach(component => {
          component.generateOptions();
        });
      }, 0);
    },
    value: function(newVal) {
      this.items = newVal;
    }
  },
  computed: {
    qtdSomatory() {
      return this.items.reduce((acc, curr) => acc + (parseInt(curr[this.qtdName]) || 0), 0);
    }
  },
  methods: {
    onAddClick() {
      this.items.push({});
    },
    onRemoveClick(index) {
      this.items.splice(index, 1);
      if (this.items.length === 0) {
        this.items.push({});
      }
      this.alterou();
    },
    isOutros(obj) {
      if(obj) {
        if(obj.nome == "Outros")
          return true;
        else
          return false;
      } else
        return false;
    },
    alterou(){
      if(this.$parent.alteracoes !== undefined){ 
        this.$parent.alteracoes = true;
      }
    }
  },
  mounted() {
    this.items = this.value;
    if (!this.items || !this.value.length) {
      this.items.push({});
    }
  },
};
</script>
<style lang="scss" scoped>
.btn-control {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  box-shadow: none;
  background: #fc6836;
  font-size: 21px;
  line-height: 21px;
  cursor: pointer;
}
</style>
